export const featuresData = [
  {
    id: 1,
    icon: 'ri-shield-check-line',
    title: '安全可靠',
    description: '采用银行级数据加密技术，多重身份验证机制，全面保障您的账户与信息安全，让您用得放心。',
  },
  {
    id: 2,
    icon: 'ri-flashlight-line',
    title: '高效便捷',
    description: '智能算法驱动，毫秒级响应速度，一键完成复杂操作流程，大幅提升您的工作与生活效率。',
  },
  {
    id: 3,
    icon: 'ri-pie-chart-2-line',
    title: '数据驱动',
    description: '深度数据分析引擎，实时生成可视化报表，帮助您洞察趋势、做出更精准的决策判断。',
  },
  {
    id: 4,
    icon: 'ri-customer-service-2-line',
    title: '专业服务',
    description: '7×24小时专属客服支持，平均响应时间不到30秒，专业团队随时为您排忧解难。',
  },
  {
    id: 5,
    icon: 'ri-smartphone-line',
    title: '多端互通',
    description: 'PC端、移动端、小程序全平台覆盖，数据实时同步，随时随地掌控一切动态。',
  },
  {
    id: 6,
    icon: 'ri-price-tag-3-line',
    title: '灵活定价',
    description: '提供多种套餐方案，按需选择、按量付费，无隐藏费用，让每一分钱都花在刀刃上。',
  },
];

export const statsData = [
  { value: '500万+', label: '注册用户', icon: 'ri-user-line' },
  { value: '99.9%', label: '服务可用率', icon: 'ri-check-double-line' },
  { value: '200+', label: '合作伙伴', icon: 'ri-team-line' },
  { value: '50+', label: '覆盖城市', icon: 'ri-map-pin-line' },
];

export const testimonialsData = [
  {
    id: 1,
    name: '张伟',
    role: '互联网创业者',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%2C%20warm%20lighting%2C%20friendly%20expression%2C%20clean%20cream%20background%2C%20modern%20business%20casual%20style%2C%20headshot%20photography&width=120&height=120&seq=avatar-01&orientation=squarish',
    rating: 5,
    content: 'jiuyou彻底改变了我的工作方式。以前需要花一整天处理的数据，现在几分钟就能完成。界面设计也很人性化，上手几乎没有学习成本。',
    date: '2026-07-20',
  },
  {
    id: 2,
    name: '李娜',
    role: '自由职业设计师',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%2C%20warm%20lighting%2C%20confident%20friendly%20smile%2C%20clean%20cream%20background%2C%20creative%20professional%20style%2C%20headshot%20photography&width=120&height=120&seq=avatar-02&orientation=squarish',
    rating: 5,
    content: '作为自由职业者，jiuyou的多端互通功能对我来说太重要了。出门在外用手机，回到家切到电脑，所有数据完美同步，效率翻倍！',
    date: '2026-07-15',
  },
  {
    id: 3,
    name: '王磊',
    role: '中小企业主',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%2C%20warm%20lighting%2C%20approachable%20confident%20look%2C%20clean%20cream%20background%2C%20business%20professional%20style%2C%20headshot%20photography&width=120&height=120&seq=avatar-03&orientation=squarish',
    rating: 4,
    content: '用了jiuyou半年，公司的运营效率提升了40%。灵活定价方案让中小企业也能享受到顶级服务，性价比真的高。',
    date: '2026-07-10',
  },
];

export const logosData = [
  { name: '合作伙伴A' },
  { name: '合作伙伴B' },
  { name: '合作伙伴C' },
  { name: '合作伙伴D' },
  { name: '合作伙伴E' },
  { name: '合作伙伴F' },
];

export const faqData = [
  {
    question: 'jiuyou平台是免费的吗？',
    answer: 'jiuyou提供基础免费版和专业付费版两种选择。基础版涵盖核心功能，适合个人用户日常使用；专业版解锁更多高级功能，满足企业和团队需求。新用户注册即可享受首单五折优惠。',
  },
  {
    question: '如何在jiuyou上注册账号？',
    answer: '注册jiuyou账号非常简单，只需访问jiuyou官网点击"立即注册"按钮，输入手机号或邮箱地址，设置密码并完成验证即可。整个过程不到一分钟。',
  },
  {
    question: 'jiuyou支持哪些设备和平台？',
    answer: 'jiuyou全面支持Windows、macOS、iOS和Android平台，同时提供微信小程序入口。无论您使用电脑、平板还是手机，都能获得一致的使用体验。',
  },
  {
    question: 'jiuyou的数据安全如何保障？',
    answer: 'jiuyou采用银行级SSL/TLS加密传输、数据分片存储、异地多活容灾等技术，已通过ISO 27001信息安全认证和等保三级认证，全方位保障用户数据安全。',
  },
  {
    question: '如果我使用中遇到问题该怎么办？',
    answer: 'jiuyou提供7×24小时在线客服支持，您可以通过官网在线客服、官方邮箱或拨打400客服热线联系我们。平均响应时间不到30秒，专业团队随时为您服务。',
  },
  {
    question: 'jiuyou支持企业定制化需求吗？',
    answer: '当然支持！jiuyou为企业客户提供定制化解决方案，包括私有化部署、API对接、专属功能开发等。请联系我们的企业服务团队获取专属方案。',
  },
];

export const aboutTimelineData = [
  { year: '2018', title: '梦想起航', description: 'jiuyou创始团队在北京成立，怀揣着改变行业格局的愿景开始创业之路。' },
  { year: '2019', title: '产品上线', description: '经过一年的潜心研发，jiuyou 1.0版本正式上线，首批用户突破1万人。' },
  { year: '2020', title: '快速成长', description: '用户突破100万，完成A轮融资，团队扩展至200人，服务覆盖全国主要城市。' },
  { year: '2022', title: '行业领先', description: '用户突破500万，荣获多项行业大奖，成为细分领域排名第一的服务平台。' },
  { year: '2024', title: '生态布局', description: '构建完整服务生态，推出多项创新产品，合作伙伴超过200家，持续引领行业发展。' },
  { year: '2026', title: '全新升级', description: '平台全面升级，引入AI智能引擎，用户体验大幅提升，开启jiuyou新篇章。' },
];

export const honorsData = [
  { year: '2025', title: '年度最佳互联网平台', issuer: '中国互联网协会' },
  { year: '2025', title: '用户满意度金奖', issuer: '中国消费者协会' },
  { year: '2024', title: '科技创新企业50强', issuer: '科技部' },
  { year: '2024', title: '数据安全优秀案例', issuer: '工信部' },
  { year: '2023', title: '最佳用户体验奖', issuer: '中国用户体验联盟' },
  { year: '2023', title: '服务质量五星认证', issuer: '中国质量认证中心' },
];

export const contactInfoData = {
  address: '北京市海淀区中关村科技园A座1806室',
  phone: '400-888-JIUYOU (400-888-549868)',
  email: 'contact@jiuyou.com',
  workingHours: '周一至周日 9:00 - 21:00',
};